// @ts-strict

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, tap } from 'rxjs/operators';
import { ExportReportsService } from './export-reports.service';

@Component({
  selector: 'app-export-reports',
  templateUrl: './export-reports.component.html',
  styleUrls: ['./export-reports.component.scss']
})
export class ExportReportsComponent implements OnInit {
  public loadingFormats = true;
  public selectOptions: { id: number; name: string }[] = [];
  public exportMenu = 'exportToFile';

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly exportReportsService: ExportReportsService
  ) {}

  ngOnInit(): void {
    this.fetchAvailableFormats();
  }

  public setExportMenu(menu: string): void {
    this.exportMenu = menu;
  }

  public close(): void {
    this.activeModal.close();
    this.modalService.dismissAll();
  }

  private fetchAvailableFormats = (): void => {
    this.exportReportsService
      .getAvailableReportsFormats()
      .pipe(
        tap(data => {
          if (data.data) {
            this.selectOptions = data.data.map((format, index) => ({ id: index, name: format }));
          }
        }),
        finalize(() => (this.loadingFormats = false))
      )
      .subscribe();
  };
}
